module.exports = __webpack_public_path__ + "static/img/Hamish_Hartlett_desktop.cfaacfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hamish_Hartlett_desktop.jpg
// module id = +aHe
// module chunks = 0